// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"522":"a246d3de0a79c703a2f2","689":"8f2b9a46685857f6ad75"}[chunkId] + ".min.js";
};